import { type ReactElement } from 'react';
import { type VehicleCycledEnergyRecord } from '../../services/battery-monitoring-api/types/battery-monitoring-api';
import Chart from '../utils/Chart';
import { type UpdateQueryParameterValues } from '../../hooks/use-update-query-parameter-values';
import useChartItems from './hooks/use-chart-items';
import { type SelectedChartSegment, cycledEnergyPerKilometerConfig } from '@/app/config/chart-segments';

interface StateOfHealthProperties {
  readonly chartVehicles: VehicleCycledEnergyRecord[];
  readonly selectedCycledEnergySegment: SelectedChartSegment | null;
  readonly updateQueryParameterValues: UpdateQueryParameterValues;
}

const CycledPerKilometerChart = ({
  chartVehicles,
  selectedCycledEnergySegment,
  updateQueryParameterValues,
}: StateOfHealthProperties): ReactElement => {
  const items = useChartItems(chartVehicles);

  return (
    <Chart
      header="Cycled Energy per kilometer"
      iconName="flash"
      items={items}
      selectedSegment={selectedCycledEnergySegment}
      indexKey={cycledEnergyPerKilometerConfig.indexKey}
      updateQueryParameterValues={updateQueryParameterValues}
    />
  );
};

export default CycledPerKilometerChart;
